// extracted by mini-css-extract-plugin
export default {"List":"AssignStudyGroupSections_List__3Xenh","SectionList":"AssignStudyGroupSections_SectionList__cY3P+"};